import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

import { IdeaDetailsComponent } from '../components/sessions/single/idea/idea.component';
import { AuthenticationService } from '../services/auth/authentication.service';

@Injectable()
export class CanDeactivateGuard {
  constructor(
    private auth: AuthenticationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
  ) {}

  canDeactivate(
    component: IdeaDetailsComponent,
  ): Observable<boolean> | boolean {
    const navigation = this.router.getCurrentNavigation();
    const ignoreGuard = navigation?.extras?.state?.['ignoreGuard'];

    if (ignoreGuard) {
      return true;
    }

    // Allow navigation if the user is not logged in
    if (!this.auth.isLoggedIn) {
      return true;
    }

    // Prompt the user if they are trying to navigate away from the empty Project page
    if (component.isEmpty) {
      return new Observable<boolean>(observer => {
        this.confirmationService.confirm({
          message: 'You have an empty Project, do you want to keep it?',
          header: 'Confirmation',
          closeOnEscape: true,
          rejectButtonProps: {
            label: 'Keep',
            severity: 'secondary',
            outlined: true,
          },
          acceptButtonProps: {
            label: 'Delete',
            severity: 'danger',
          },
          accept: () => {
            component.deleteIdea();
            observer.next(true);
            observer.complete();
            this.messageService.add({
              severity: 'info',
              summary: 'Success',
              detail: 'Empty Project Deleted',
            });
          },
          reject: () => {
            observer.next(true);
            observer.complete();
          },
        });
      });
    }

    // If the Project is editing, ask to save changes
    if (component.isEditing) {
      return component.dismissChanges();
    }

    return true;
  }
}
